module.exports = __webpack_public_path__ + "img/vertical_3_7_7005.1b2b7e3f.png";